import image1 from './pexels-andrea-imre-10550212.jpg';
import image2 from './pexels-jan-caluwé-15917391.jpg';
import image3 from './pexels-luis-quintero-14302882.jpg';
import image4 from './pexels-maria-frost-15733741.jpg';
import image5 from './pexels-pixabay-258154.jpg';
import image6 from './pexels-thorsten-technoman-338504.jpg';
import image7 from './pexels-victor-fevrier-15879065.jpg';

const images = [image1, image2, image3, image4, image5, image6, image7];

export default images;